"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeEmail = void 0;
var normalizeEmail = function (email) {
    return email.trim().toLowerCase();
};
exports.normalizeEmail = normalizeEmail;
